import styles from "./FooterBar.module.css";
import {Link, NavLink} from "react-router-dom";

function FooterBar() {
    return (
        <footer className={`${styles.footer} footer py-4 mt-5`}>
            <div className={`container ${styles.inner}`}>
                <p className="mb-0">&copy; {new Date().getFullYear()} Code Venture Labs. All rights reserved.</p>
                <div className={styles.links}>
                    <Link to="/privacy">Privacy Policy</Link>
                    <Link to="/terms">Terms of Service</Link>
                </div>
            </div>
        </footer>
    );
}

export default FooterBar;